import React from 'react';
import { Box, Typography } from '@mui/material';
import type { IReportingHeaderProps } from '../interfaces';

export const ReportingHeader = ({
  title = 'Reporting',
  subtitle = 'HierTalent recruitment analytics',
}: IReportingHeaderProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        px: { xs: 2, sm: 3 },
        py: 2,
      }}
    >
      <Box>
        <Typography variant="h2" sx={{ fontWeight: 700, color: 'text.primary' }}>
          {title}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.25 }}>
          {subtitle}
        </Typography>
      </Box>
    </Box>
  );
};
